module.exports = __webpack_public_path__ + "static/media/video-breathing-es.7166439a.vtt";